import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { DateProvider } from '../../../providers';
import {
  CenterCointer,
  Container,
  FlagContainerAway,
  FlagContainerHome,
  Points,
  PointsContainer,
  Space,
  TeamContainer,
  TeamNameAway,
  TeamNameHome,
  Timer,
  TimerContainer,
} from './styles';

function SoccerWorldCup2022({ data }) {
  const { awayTeam, homeTeam, status, time } = data;
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (time.length === 0) return '00:00';
    const [minutes, seconds] = DateProvider.getSoccerTime(time);
    return `${minutes}:${seconds}`;
  };

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Container>
        <FlagContainerHome
          width="70"
          height="70"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <rect
            x="35"
            y="2.82843"
            width="45.4975"
            height="45.4975"
            transform="rotate(45 35 2.82843)"
            fill="#82182E"
            stroke="white"
            stroke-width="4"
          />
          <mask
            id="mask0_1916_3013"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="5"
            y="5"
            width="60"
            height="61"
          >
            <rect
              x="34.998"
              y="8.10821"
              width="38.2378"
              height="38.2378"
              transform="rotate(45 34.998 8.10821)"
              fill="#82182E"
              stroke="white"
              stroke-width="4"
            />
          </mask>
          <g mask="url(#mask0_1916_3013)">
            <rect
              x="-5.27979"
              y="5.27979"
              width="81.1758"
              height="61.3769"
              fill="url(#pattern0)"
            />
          </g>
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_1916_3013"
                transform="translate(-0.00406524, -0.08) scale(0.000840109 0.00126111)"
              />
            </pattern>
            <image
              id="image0_1916_3013"
              width="1200"
              height="900"
              xlinkHref={homeTeam.image}
            />
          </defs>
        </FlagContainerHome>
        <TeamContainer>
          <TeamNameHome>{homeTeam.name}</TeamNameHome>
          <CenterCointer>
            <PointsContainer>
              <Points>{homeTeam.points}</Points>
              <Space>:</Space>
              <Points>{awayTeam.points}</Points>
            </PointsContainer>
            <TimerContainer>
              <Timer>{getTime()}</Timer>
            </TimerContainer>
          </CenterCointer>
          <TeamNameAway>{awayTeam.name}</TeamNameAway>
        </TeamContainer>
        <FlagContainerAway
          width="70"
          height="70"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <rect
            x="35"
            y="2.82843"
            width="45.4975"
            height="45.4975"
            transform="rotate(45 35 2.82843)"
            fill="#82182E"
            stroke="white"
            stroke-width="4"
          />
          <mask
            id="mask0_1916_3014"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="5"
            y="5"
            width="60"
            height="61"
          >
            <rect
              x="34.998"
              y="8.10821"
              width="38.2378"
              height="38.2378"
              transform="rotate(45 34.998 8.10821)"
              fill="#82182E"
              stroke="white"
              stroke-width="4"
            />
          </mask>
          <g mask="url(#mask0_1916_3014)">
            <rect
              x="-5.27979"
              y="5.27979"
              width="81.1758"
              height="61.3769"
              fill="url(#pattern1)"
            />
          </g>
          <defs>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_1916_3014"
                transform="translate(-0.00406524, -0.08) scale(0.000840109 0.00126111)"
              />
            </pattern>
            <image
              id="image0_1916_3014"
              width="1200"
              height="900"
              xlinkHref={awayTeam.image}
            />
          </defs>
        </FlagContainerAway>
      </Container>
    </>
  );
}

SoccerWorldCup2022.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
  }),
  styles: PropTypes.shape({}),
};

SoccerWorldCup2022.defaultProps = {
  data: {
    awayTeam: {
      colors: [],
      image:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Argentina.svg/1200px-Flag_of_Argentina.svg.png',
      name: 'ARG',
      points: 1,
    },
    homeTeam: {
      colors: [],
      image:
        'https://www.banderasphonline.com/wp-content/uploads/2021/08/comprar-bandera-espana-sin-escudo-para-exterior-interior-1200x900.png',
      name: 'ESP',
      points: 0,
    },
    status: 'paused',
    time: [],
  },
  styles: {},
};

export default SoccerWorldCup2022;
